"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@mapmaker/ui");
const react_1 = require("react");
const client_1 = require("../../../client");
function CreateMapmakerProjectButton(_a) {
    var { designId, initialFileProperties = {}, children } = _a, buttonProps = __rest(_a, ["designId", "initialFileProperties", "children"]);
    const { gotoNewFile } = (0, client_1.useMapmakerAppConfig)();
    const onClick = (0, react_1.useCallback)(() => {
        gotoNewFile(designId, initialFileProperties);
    }, [designId, initialFileProperties]);
    return ((0, jsx_runtime_1.jsx)(ui_1.Button, Object.assign({ onClick: onClick }, buttonProps, { children: children })));
}
exports.default = CreateMapmakerProjectButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3JlYXRlTWFwbWFrZXJQcm9qZWN0QnV0dG9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc2hhcmVkL2J1dHRvbnMvQ3JlYXRlTWFwbWFrZXJQcm9qZWN0QnV0dG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7OztBQUFBLHFDQUFvRDtBQUVwRCxpQ0FBb0M7QUFDcEMsNENBQXVEO0FBT3ZELFNBQXdCLDJCQUEyQixDQUFDLEVBS2pCO1FBTGlCLEVBQ2xELFFBQVEsRUFDUixxQkFBcUIsR0FBRyxFQUFFLEVBQzFCLFFBQVEsT0FFeUIsRUFEOUIsV0FBVyxjQUpvQyxpREFLbkQsQ0FEZTtJQUVkLE1BQU0sRUFBRSxXQUFXLEVBQUUsR0FBRyxJQUFBLDZCQUFvQixHQUFFLENBQUM7SUFDL0MsTUFBTSxPQUFPLEdBQUcsSUFBQSxtQkFBVyxFQUFDLEdBQUcsRUFBRTtRQUMvQixXQUFXLENBQUMsUUFBUSxFQUFFLHFCQUFxQixDQUFDLENBQUM7SUFDL0MsQ0FBQyxFQUFFLENBQUMsUUFBUSxFQUFFLHFCQUFxQixDQUFDLENBQUMsQ0FBQztJQUN0QyxPQUFPLENBQ0wsdUJBQUMsV0FBTSxrQkFBQyxPQUFPLEVBQUUsT0FBTyxJQUFNLFdBQVcsY0FDdEMsUUFBUSxJQUNGLENBQ1YsQ0FBQztBQUNKLENBQUM7QUFmRCw4Q0FlQyJ9